const buttons = document.querySelectorAll('[data-scroll-up="true"]');

const isVisible = (element) => {
  if (!(element instanceof HTMLElement)) return false;

  const style = window.getComputedStyle(element);

  return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
};

const getProductScrollTarget = () => {
  const sizeSelector = document.querySelector(
    "variant-picker[ref='mainVariantPicker'] .variant-option--button-prices"
  );

  if (!isVisible(sizeSelector)) return null;

  const rect = sizeSelector.getBoundingClientRect();
  const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
  const clearance = 18;
  const selectorBottom = window.scrollY + rect.bottom;

  return Math.max(0, Math.round(selectorBottom - viewportHeight + clearance));
};

const getBackToTopTarget = () => {
  const productTarget = getProductScrollTarget();

  return productTarget ?? 0;
};

buttons.forEach((button) => {
  if (button.dataset.scrollUpBound === 'true') return;

  button.dataset.scrollUpBound = 'true';
  button.addEventListener('click', () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    button.classList.add('is-scrolling');
    window.scrollTo({
      top: getBackToTopTarget(),
      behavior: reduceMotion ? 'auto' : 'smooth',
    });

    if (reduceMotion) {
      button.classList.remove('is-scrolling');
      return;
    }

    window.setTimeout(() => {
      button.classList.remove('is-scrolling');
    }, 700);
  });
});
